import type { ReactNode } from 'react';
import { Suspense } from 'react';

import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { NethoneProvider } from '@sorare/core/src/contexts/nethone/Provider';
import { lazy } from '@sorare/core/src/lib/retry';

import type { Props as PaymentBoxProps } from '../PaymentBox';
import type { Props as PaymentDialogProps } from '../PaymentDialog';
import type { PaymentProps } from '../PaymentProvider';

const PaymentProvider = lazy(
  async () => import('components/buyActions/PaymentProvider'),
  'ContextProvider'
);
const PaymentBox = lazy(
  async () => import('components/buyActions/PaymentBox'),
  'PaymentBox'
);
const PaymentDialog = lazy(
  async () => import('components/buyActions/PaymentDialog'),
  'PaymentDialog'
);

type Props = {
  fallback?: ReactNode;
  paymentProps: PaymentProps;
  paymentBoxProps?: PaymentBoxProps;
  paymentDialogProps?: PaymentDialogProps;
};

export const LazyPaymentProvider = ({
  paymentProps,
  paymentBoxProps,
  paymentDialogProps,
  fallback = null,
}: Props) => {
  return (
    <Suspense fallback={fallback}>
      <NethoneProvider>
        <PaymentProvider {...paymentProps}>
          <ConditionalWrapper
            wrap={!!paymentDialogProps}
            Wrapper={PaymentDialog}
            props={paymentDialogProps}
          >
            <PaymentBox {...paymentBoxProps} />
          </ConditionalWrapper>
        </PaymentProvider>
      </NethoneProvider>
    </Suspense>
  );
};
